import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import Autorenew from '@material-ui/icons/Autorenew';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import Radio from '@material-ui/core/Radio';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import 'moment/locale/pt-br';
import telefone from 'telefone';
import iuguService from '../../services/IUGU';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';

const useStyles = (theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  selectTipo: {
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: 800,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    top: `50%`,
    left: `50%`,
    transform: `translate(-50%, -50%)`,
    width: '80%',
    height: '80%',
    overflow: 'auto',
  },
  loading: {
    marginLeft: '50%',
  },
});

class CobrancasComponent extends Component {
  constructor() {
    super();
    this.axios = instanceAxios(localStorage.getItem('toobiauth'));
    moment.locale('pt-br');
  }

  state = {
    columns: [
      { id: 'usuario', label: 'Usuário', minWidth: 170 },
      { id: 'email', label: 'e-mail', minWidth: 170 },
      { id: 'telefone', label: 'Telefone', minWidth: 170 },
      { id: 'assinatura', label: 'Assinatura', minWidth: 170 },
      { id: 'valorCobrado', label: 'Valor Cobrado', minWidth: 170 },
      { id: 'dataVencimento', label: 'Data de Vencimento', minWidth: 170 },
      { id: 'dataPagamento', label: 'Data de Pagamento', minWidth: 170 },
      { id: 'status', label: 'Status', minWidth: 170 },
      { id: 'fatura', label: 'Fatura', minWidth: 170 },
      { id: 'cancelar', label: 'Cancelar', minWidth: 85 },
      { id: 'novo', label: 'Nova Fatura', minWidth: 85 },
    ],
    tipoCobranca: '',
    qtdFaturas: 1,
    size: 10,
    limit: 10,
    offset: 0,
    data: [],
    clientes: [],
    openModal: false,
    metodo: '',
    cliente: null,
    servicos: [],
    servico: null,
    descricao: '',
    valor: '',
    numeroCartao: '',
    busca: '',
    verificacaoCartao: '',
    primeiroNomeCartao: '',
    segundoNomeCartao: '',
    mesCartao: '',
    anoCartao: '',
    parcelas: 1,
    creditCard: 'padrao',
    openError: false,
    openSucess: false,
    openWarning: false,
  };

  componentWillMount() {
    this.axios
      .get(`${environment}/listarCobrancas/servicos?nome=`)
      .then((res) => {
        console.log(res.data);
        const cobancas = res.data;
        this.setState({ data: cobancas });
        this.setState({ tipoCobranca: 'servicos' });
      });
    this.axios.get(`${environment}/clientes?nome=`).then((res) => {
      const clientes = res.data.rows;
      this.setState({ clientes });
    });
    this.axios.get(`${environment}/servicos`).then((res) => {
      const servicos = res.data;
      this.setState({ servicos });
    });
  }

  clickAlert = () => {
    this.setState({ openError: false });
    this.setState({ openSucess: false });
    this.setState({ openWarning: false });
  };

  handleBusca = async (event) => {
    const tipo = this.state.tipoCobranca;
    this.setState({ tipoCobranca: '' });
    this.setState({ busca: event.target.value });
    await this.axios
      .get(`${environment}/listarCobrancas/${tipo}?nome=${event.target.value}`)
      .then((res) => {
        const cobancas = res.data;
        this.setState({ data: cobancas });
        this.setState({ tipoCobranca: tipo });
      });
  };

  handleChangePage = (event) => {
    console.log(event);
  };

  handleChangeRowsPerPage = (event) => {
    console.log(event.target.value);
    console.log(this.state.limit);
    this.setState({ limit: event.target.value });
    console.log(this.state.limit);
  };

  handleCreditCard = (event) => {
    this.setState({ creditCard: event.target.value });
  };

  handleModal = () => {
    const status = !this.state.openModal;
    this.setState({ openModal: status });
    this.clickAlert();
  };

  handleClickCancelar = async (id) => {
    this.setState({ openWarning: true });
    await this.axios
      .put(`${environment}/cancelarFatura/${id}`)
      .then((res) => this.setState({ openSucess: true }))
      .catch((err) => this.setState({ openError: true }));
  };

  handleClickNovo = async (id, cliente, items) => {
    // Criando objeto cobrança
    const cobranca = {
      method: 'bank_slip',
      email: cliente.email,
      cpf_cnpj: cliente.cpf,
      id_usuario: cliente.id,
      items: [
        {
          description: items[0].description,
          quantity: items[0].quantity,
          price_cents: items[0].price_cents,
        },
      ],
      zip_code: cliente.EnderecoUsuario.cep,
      customer_id: cliente.id_iugu,
      number: cliente.EnderecoUsuario.numero,
    };

    this.setState({ openWarning: true });
    await this.axios
      .post(`${environment}/novaCobranca/${id}`, cobranca)
      .then((res) => this.setState({ openSucess: true }))
      .catch((err) => this.setState({ openError: true }));
  };

  selectTipoCobranca = async (event) => {
    this.setState({ tipoCobranca: '' });
    await this.axios
      .get(
        `${environment}/listarCobrancas/${event.target.value}/?nome=${this.state.busca}`
      )
      .then((res) => {
        const cobancas = res.data;
        this.setState({ data: cobancas });
        this.setState({ tipoCobranca: event.target.value });
      });
  };

  selectMetodo = (event) => {
    this.setState({ metodo: event.target.value });
  };

  selectCliente = (event) => this.setState({ cliente: event.target.value });

  selectServico = (event) => {
    this.setState({ servico: event.target.value });
    this.setState({ descricao: event.target.value.descricao });
    this.setState({ valor: event.target.value.valor });
  };

  createCobranca = () => {
    // Criando objeto cobrança
    const cobranca = {
      method: this.state.metodo,
      email: this.state.cliente.email,
      cpf_cnpj: this.state.cliente.cpf,
      id_usuario: this.state.cliente.id,
      id_servico: this.state.servico.id,
      items: [
        {
          description: this.state.descricao,
          quantity: 1,
          price_cents: Number(this.state.valor) * 100,
        },
      ],
      zip_code: this.state.cliente.EnderecoUsuario.cep,
      customer_id: this.state.cliente.id_iugu,
    };

    if (this.state.metodo === 'bank_slip') {
      cobranca.number = this.state.cliente.EnderecoUsuario.numero;
    } else if (this.state.metodo === 'credit_card') {
      // PEGAR ENDEREÇO DO CLIENTE
      cobranca.months = this.state.qtdFaturas;
      cobranca.address_number = this.state.cliente.EnderecoUsuario.numero;
      cobranca.street = this.state.cliente.EnderecoUsuario.logradouro;
      cobranca.name = this.state.cliente.nome;
      cobranca.number = this.state.numeroCartao;
      cobranca.verification_value = this.state.verificacaoCartao;
      cobranca.first_name = this.state.primeiroNomeCartao;
      cobranca.last_name = this.state.segundoNomeCartao;
      cobranca.month = this.state.mesCartao;
      cobranca.year = this.state.anoCartao;
      cobranca.test = true;
    }
    // Realizando cobrança
    this.setState({ openModal: false });
    this.setState({ openWarning: true });
    this.axios
      .post(`${environment}/realizarCobrancaDireta`, cobranca)
      .then((data) => {
        this.setState({ openSucess: true });
      })
      .catch((err) => {
        this.setState({ openError: true });
      });
  };

  render() {
    const { classes } = this.props;

    return (
      <div style={{ margin: 20 }}>
        <Collapse in={this.state.openError}>
          <Alert severity="error" onClick={this.clickAlert}>
            Erro realizar ação,tente mais tarde!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openSucess}>
          <Alert severity="success" onClick={this.clickAlert}>
            Ação realizada Com Sucesso!
          </Alert>
        </Collapse>
        <Collapse in={this.state.openWarning}>
          <Alert severity="Warning" onClick={this.clickAlert}>
            Aguarde!
          </Alert>
        </Collapse>
        <h1 style={{ marginLeft: 1 }}>Cobrancas</h1>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: 10,
          }}
        >
          <TextField
            id="tipo-cobranca"
            select
            label="Tipo de Cobrança"
            value={this.state.tipoCobranca}
            onChange={this.selectTipoCobranca}
            className={classes.selectTipo}
          >
            <MenuItem value="servicos">Serviços</MenuItem>
            <MenuItem value="boletos">Boletos</MenuItem>
            <MenuItem value="assinaturas">Assinaturas</MenuItem>
          </TextField>
          <Button
            variant="contained"
            style={{
              backgroundColor: XMEI_PRIMARY_COLOR,
              color: '#FFF',
            }}
            className={classes.button}
            onClick={this.handleModal}
          >
            Nova Cobrança
          </Button>
          <TextField
            id="busca"
            label="Busca"
            value={this.state.busca}
            onChange={this.handleBusca}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </div>
        <Paper>
          <Collapse in={this.state.tipoCobranca !== ''}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {this.state.columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.data.map((d) => {
                  const dataPagamento = d.dados.paid_at
                    ? moment(d.dados.paid_at).format('L')
                    : '';
                  const dataVencimento = d.dados.due_date
                    ? moment(d.dados.due_date).format('L')
                    : '';

                  if (this.state.tipoCobranca === 'servicos') {
                    const assinatura = d.ServicoContratado.Usuario
                      .PlanoAssinaturaUsuario
                      ? d.ServicoContratado.Usuario.PlanoAssinaturaUsuario
                          .status
                      : 'Não Assinante';

                    return (
                      <TableRow key={d.id_fatura}>
                        <TableCell component="th" scope="row">
                          {d.ServicoContratado.Usuario.nome}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.ServicoContratado.Usuario.email}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {telefone.format(
                            d.ServicoContratado.Usuario.telefone
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {assinatura}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.dados.total}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dataVencimento}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dataPagamento}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {iuguService.convertStatus(d.dados.status)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            size="small"
                            color="primary"
                            href={d.dados.secure_url}
                            target="blank"
                          >
                            Link
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <NotInterestedIcon />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <NotInterestedIcon />
                        </TableCell>
                      </TableRow>
                    );
                  }
                  if (this.state.tipoCobranca === 'boletos') {
                    const assinatura = d.User.PlanoAssinaturaUsuario
                      ? d.User.PlanoAssinaturaUsuario.status
                      : 'Não Assinante';

                    return (
                      <TableRow key={d.id_fatura}>
                        <TableCell component="th" scope="row">
                          {d.User.nome}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.User.email}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {telefone.format(d.User.telefone)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {assinatura}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.dados.total}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dataVencimento}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {dataPagamento}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {iuguService.convertStatus(d.dados.status)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            size="small"
                            color="primary"
                            href={d.dados.secure_url}
                            target="blank"
                          >
                            Link
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            disabled={d.dados.status !== 'pending'}
                            size="small"
                            variant="contained"
                            color="secondary"
                            onClick={() =>
                              this.handleClickCancelar(d.id_fatura)
                            }
                            startIcon={<DeleteIcon />}
                          >
                            Cancelar
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            disabled={d.dados.status !== 'pending'}
                            size="small"
                            variant="contained"
                            onClick={() =>
                              this.handleClickNovo(
                                d.id_fatura,
                                d.User,
                                d.dados.items
                              )
                            }
                            startIcon={<Autorenew />}
                          >
                            Novo
                          </Button>
                        </TableCell>
                      </TableRow>
                    );
                  }
                  if (this.state.tipoCobranca === 'assinaturas') {
                    return (
                      <TableRow key={d.id_fatura}>
                        <TableCell component="th" scope="row">
                          {d.User.nome}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.User.email}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {telefone.format(d.User.telefone)}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.PlanoAssinatura.nome}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {`R$${d.valor / 100}`}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.PlanoAssinaturaUsuario
                            ? moment(
                                d.PlanoAssinaturaUsuario.data_vencimento
                              ).format('L')
                            : ''}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.PlanoAssinaturaUsuario
                            ? moment(
                                d.PlanoAssinaturaUsuario.data_vencimento
                              ).format('L')
                            : ''}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {d.PlanoAssinaturaUsuario
                            ? d.PlanoAssinaturaUsuario.status
                            : ''}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <Button
                            size="small"
                            color="primary"
                            href={d.url_fatura_pdf}
                            target="blank"
                          >
                            Link
                          </Button>
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <NotInterestedIcon />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <NotInterestedIcon />
                        </TableCell>
                      </TableRow>
                    );
                  }
                })}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={this.state.limit}
              rowsPerPage={this.state.limit}
              page={this.state.offset}
              onChangePage={this.handleChangePage}
              onChangeRowsPerPage={this.handleChangeRowsPerPage}
            />
          </Collapse>
          <Collapse in={this.state.tipoCobranca === ''}>
            <CircularProgress className={classes.loading} />
          </Collapse>
        </Paper>

        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={this.state.openModal}
          onClose={this.handleModal}
        >
          <div className={classes.paper}>
            <h2 id="simple-modal-title">Nova Cobrança</h2>
            <TextField
              select
              label="Cliente"
              labelId="clientes"
              fullWidth
              id="clientes"
              onChange={this.selectCliente}
            >
              {this.state.clientes.map((c) => {
                return <MenuItem value={c}>{c.nome}</MenuItem>;
              })}
            </TextField>
            <TextField
              select
              label="Metodo Pagamento"
              labelId="metodo"
              fullWidth
              id="metodo"
              onChange={this.selectMetodo}
            >
              <MenuItem value="credit_card">Cartão Crédito</MenuItem>
              <MenuItem value="bank_slip">Boleto Bancário</MenuItem>
            </TextField>
            <TextField
              select
              labelId="servicos"
              id="servicos"
              fullWidth
              onChange={this.selectServico}
              label="Serviço"
            >
              {this.state.servicos.map((s) => {
                return <MenuItem value={s}>{s.nome}</MenuItem>;
              })}
            </TextField>
            <TextField
              multiline
              label="Descrição"
              fullWidth
              value={this.state.descricao}
              onChange={(descricao) => {
                this.setState({ descricao: descricao.target.value });
              }}
            />
            <TextField
              label="Valor"
              fullWidth
              value={this.state.valor}
              onChange={(valor) => {
                this.setState({ valor: valor.target.value });
              }}
            />
            <Collapse in={this.state.metodo === 'credit_card'}>
              <FormControl component="fieldset" style={{ marginTop: '2%' }}>
                <FormLabel component="legend">Cartão Crédito</FormLabel>
                <RadioGroup
                  aria-label="cartaoCredito"
                  name="cartaoCredito"
                  value={this.state.creditCard}
                  onChange={this.handleCreditCard}
                  row
                >
                  <FormControlLabel
                    value="padrao"
                    control={<Radio />}
                    label="Padrão"
                  />
                  <FormControlLabel
                    value="novo"
                    control={<Radio />}
                    label="Novo"
                  />
                </RadioGroup>
              </FormControl>
              <Collapse in={this.state.creditCard === 'novo'}>
                <h3 style={{ marginTop: '2%' }}>Dados Do Cartão de Crédito</h3>
                <TextField
                  label="Numero do Cartão"
                  fullWidth
                  value={this.state.numeroCartao}
                  onChange={(num) => {
                    this.setState({ numeroCartao: num.target.value });
                  }}
                />
                <TextField
                  label="Qtd.Parcelas"
                  value={this.state.qtdFaturas}
                  type="number"
                  onChange={(f) => {
                    this.setState({ qtdFaturas: f.target.value });
                  }}
                />
                <TextField
                  label="Código de Verificação"
                  value={this.state.verificacaoCartao}
                  onChange={(ver) => {
                    this.setState({ verificacaoCartao: ver.target.value });
                  }}
                />
                <TextField
                  label="Primeiro Nome do titular"
                  fullWidth
                  value={this.state.primeiroNomeCartao}
                  onChange={(pn) => {
                    this.setState({ primeiroNomeCartao: pn.target.value });
                  }}
                />
                <TextField
                  label="Segundo nome do titular"
                  fullWidth
                  value={this.state.segundoNomeCartao}
                  onChange={(sn) => {
                    this.setState({ segundoNomeCartao: sn.target.value });
                  }}
                />
                <TextField
                  label="Mês de vencimento"
                  value={this.state.mesCartao}
                  onChange={(mes) => {
                    this.setState({ mesCartao: mes.target.value });
                  }}
                />
                <TextField
                  label="Ano de vencimento"
                  value={this.state.anoCartao}
                  onChange={(ano) => {
                    this.setState({ anoCartao: ano.target.value });
                  }}
                />
              </Collapse>
            </Collapse>

            <Button
              variant="contained"
              color="primary"
              size="small"
              className={classes.button}
              startIcon={<SaveIcon />}
              onClick={this.createCobranca}
            >
              Criar
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default withStyles(useStyles)(CobrancasComponent);
